<template>
  <div :class="{ 'full-width': block }">
    <template v-if="icon">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!openAsLink"
            @click="downloadFile"
            :color="color"
            icon
            v-bind="attrs"
            v-on="on"
            :class="classList"
            :x-large="xLarge"
            :block="block"
            :disabled="disabled"
            :loading="isDownloading"
          >
            <v-icon>
              mdi-cloud-download
            </v-icon>
          </v-btn>
          <v-btn
            v-else
            :href="url"
            @click="clickedLink"
            target="_blank"
            icon
            :color="color"
            v-bind="attrs"
            v-on="on"
            :class="classList"
            :x-large="xLarge"
            :block="block"
            :disabled="disabled"
          >
            <v-icon>
              mdi-cloud-download
            </v-icon>
          </v-btn>
        </template>
        {{ buttonText }}
      </v-tooltip>
    </template>

    <template v-else>
      <v-btn
        v-if="!openAsLink"
        @click="downloadFile"
        :color="color"
        :outlined="outlined"
        :class="classList"
        :x-large="xLarge"
        :block="block"
        :disabled="disabled"
        :loading="isDownloading"
      >
        {{ buttonText }}
        <v-icon
          right
        >
          mdi-cloud-download
        </v-icon>
      </v-btn>
      <v-btn
        v-else
        :href="url"
        @click="clickedLink"
        target="_blank"
        :color="color"
        :outlined="outlined"
        :class="classList"
        :x-large="xLarge"
        :block="block"
        :disabled="disabled"
      >
        {{ buttonText }}
        <v-icon
          right
        >
          mdi-cloud-download
        </v-icon>
      </v-btn>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import API from '@/services/API.ts'

export default {
  name: 'DownloadButton',
  props: {
    url: String,
    buttonText: String, // buttonText visas som en tooltip om icon
    color: {
      type: String,
      default: 'primary'
    },
    icon: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    openInline: {
      type: Boolean,
      default: false
    },
    classList: {
      type: String,
      default: ''
    },
    xLarge: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    requestFile: {
      type: Boolean,
      default: false
    },
    fileName: String
  },
  data: () => ({
    isDownloading: false,
    downloadObjectUrl: null
  }),
  computed: {
    ...mapState(
      {
        isElectron: state => state.isElectron
      }
    ),
    openAsLink: function () {
      return !this.requestFile && (!this.isElectron || this.openInline)
    }
  },
  methods: {
    downloadFile: async function () {
      if (this.requestFile) {
        if (this.isDownloading) {
          return
        }

        this.isDownloading = true
        try {
          const response = await API.httpClient.get(this.url, { responseType: 'blob' })
          const contentDisposition = response.headers?.['content-disposition'] || ''
          const fileNameMatch = contentDisposition.match(/filename="?([^";]+)"?/i)
          this.revokeDownloadObjectUrl()
          this.downloadObjectUrl = window.URL.createObjectURL(response.data)
          const link = document.createElement('a')
          link.href = this.downloadObjectUrl
          link.download = this.fileName || fileNameMatch?.[1] || 'download'
          document.body.appendChild(link)
          link.click()
          link.remove()
          this.$emit('downloaded')
        } finally {
          this.isDownloading = false
        }
        return
      }

      window.shell.openExternalLink(this.url)
      this.$emit('downloaded')
    },
    clickedLink: function () {
      this.$emit('downloaded')
    },
    revokeDownloadObjectUrl: function () {
      if (this.downloadObjectUrl) {
        window.URL.revokeObjectURL(this.downloadObjectUrl)
        this.downloadObjectUrl = null
      }
    }
  },
  watch: {},
  beforeDestroy () {
    this.revokeDownloadObjectUrl()
  }
}
</script>
